import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HeaderScrollService {
    private observer: IntersectionObserver | null = null;
    private readonly _heroVisible = signal(false);

    public readonly heroVisible = this._heroVisible.asReadonly();

    public registerHeroElement(element: HTMLElement): void {
        this.disconnectObserver();

        this.observer = new IntersectionObserver(
            entries => {
                const [entry] = entries;
                this._heroVisible.set(entry.isIntersecting);
            },
            {
                threshold: 0,
                rootMargin: '-90px 0px 0px 0px' // Account for header height
            }
        );

        this.observer.observe(element);
        this._heroVisible.set(true); // Initially visible when registered
    }

    public unregisterHeroElement(): void {
        this.disconnectObserver();
        this._heroVisible.set(false);
    }

    private disconnectObserver(): void {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}
